import { forwardRef, Ref, useImperativeHandle, useRef } from 'react';
import { useForkRef } from '@mui/material/utils';
import { PickersSectionListRef } from '@mui/x-date-pickers/PickersSectionList';
import { PickersTextField, PickersTextFieldProps } from '@mui/x-date-pickers/PickersTextField';

type SeriesDateRangeTextFieldProps = PickersTextFieldProps & {
  startLocked?: boolean;
  formFieldRef?: Ref<{ focus: () => void }>;
};

// Preserve the historical start in the shared single field while keeping its end editable.
export const SeriesDateRangeTextField = forwardRef<HTMLDivElement, SeriesDateRangeTextFieldProps>(
  ({ startLocked, formFieldRef, ...props }, ref) => {
    const sectionsRef = useRef<PickersSectionListRef>(null);
    const handleSectionListRef = useForkRef(props.sectionListRef, sectionsRef);

    useImperativeHandle(formFieldRef, () => ({
      focus: () => sectionsRef.current?.getSectionContent(startLocked ? 3 : 0).focus(),
    }));

    return (
      <PickersTextField
        {...props}
        ref={ref}
        sectionListRef={handleSectionListRef}
        InputProps={{ ...props.InputProps, 'aria-label': 'Dates', 'aria-labelledby': undefined, 'aria-required': true }}
        elements={props.elements.map((element, index) =>
          startLocked && index < 3
            ? {
                ...element,
                content: {
                  ...element.content,
                  contentEditable: false,
                  tabIndex: -1,
                  'aria-readonly': true,
                  'aria-disabled': true,
                },
              }
            : element
        )}
      />
    );
  }
);
SeriesDateRangeTextField.displayName = 'SeriesDateRangeTextField';
